import { UserLedgerList } from './userLedgerList'


/**
 * CashBack
 * Displays the cashback ledger for the user.
 */
export const CashBack = ({ data, isUserLoading }) => {

    return (<>
        <UserLedgerList />


    </>
    )
}











